// eslint-disable-next-line
import React, { forwardRef, useEffect, useRef, useState } from 'react';

import * as MuiCore from '@material-ui/core';
import Appbar from './Appbar';
import SideDrawer from './SideDrawer';
import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import { getAgentUserSession } from 'core/selectors';

const MainContainer = MuiCore.styled('div')(({ theme }) => ({
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',

}))

const ContentContainer = MuiCore.styled('div')(({ theme }) => ({
    maxHeight: '100vh',
    // overflowX: 'scroll',
    overflowY: 'scroll',
    width: '100vw',
    height:'100%',
    marginLeft: '0px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    zIndex: 1,
    [theme.breakpoints.up('md')]: {
        position: 'relative',
        width: `calc(100vw - ${theme.sizes.drawerWidth})`,
        marginLeft: `${theme.sizes.drawerWidth}`,
        // transform: 'translate3d(0,0,0)',
    }
}))

const MainContent = MuiCore.styled('div')(({ theme, agentUserSession=false }) => ({
    width: `100%`,
    height: `calc(100vh - ${agentUserSession ? theme.sizes.agentSessionAppBar : theme.sizes.appBar})`,
    padding: theme.spacing(1)
}))


const MainLayout= forwardRef(({ children, isMobile }, ref)=> {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { pathname } = useLocation();
    const contentContainerRef = useRef()
    const agentUserSession = useSelector(state=>getAgentUserSession(state))
    useEffect(() => {
        const handleResize = () => {
            if (isMobile) {
                setDrawerOpen(false)
            }
            else {
                setDrawerOpen(true)
            }
        }
        handleResize()
    }, [isMobile])

    useEffect(() => {
        if (contentContainerRef.current)
            contentContainerRef.current.scrollTop = 0
    }, [pathname])

    return (

        <MainContainer>
            <SideDrawer isMobile={isMobile} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
            <ContentContainer ref={contentContainerRef}>
                <Appbar phoneButtonRef={ref} isMobile={isMobile} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                <MainContent agentUserSession={Boolean(agentUserSession)}>
                    {children}
                </MainContent>
            </ContentContainer>
        </MainContainer>
    )
})

export default MainLayout